import React, { Fragment } from 'react';
import { Button, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList} from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import DescriptionIcon from '@material-ui/icons/Description';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
const ExportManu = ({disabled, exportReportFn, files, title, marginbottom, otherMenu}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event, file, triggerExport) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    if(triggerExport){
      exportReportFn(file);
    }
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);
  return(
    <Fragment>
      <Button
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        color="primary"
        disabled={disabled}
        variant={otherMenu?.length?undefined:"outlined"}
        size='small'
      >
        <SaveAltIcon style={{fontSize: '1.15rem'}} />{ title ? title:'Export'}
        {otherMenu?.length?<ArrowDropDownIcon />: null}
      </Button>
      <Popper placement= {otherMenu?.length? "bottom-start" :"bottom-end"} style={{zIndex: '9'}} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom', }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  {files && files.map((file, index) =>
                    <MenuItem onClick={(event) => handleClose(event,file, 'triggerExport')}>
                      {file.extension === 'pdf' ? <PictureAsPdfIcon /> : file.extension === 'csv' || file.extension === 'xls' ? <DescriptionIcon /> : <InsertDriveFileIcon />  }
                      { file.title}
                    </MenuItem>
                  )}
                  {otherMenu?.length && otherMenu?.map((type,index)=>
                      <MenuItem onClick={(event) => handleClose(event,type, 'triggerExport')}>
                   <div style={{fontSize:'12px', display:'flex'}}>{ type.title}</div>
                  </MenuItem>
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Fragment>
  )
}

export default ExportManu;
